import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FiHome, FiUsers, FiBarChart2, FiSettings, FiLogOut, FiShield } from 'react-icons/fi';
import { logOut } from '../../services/authService';
import { useAuth } from '../../hooks/useAuth';
import { useTranslation } from '../../i18n/useTranslation';
import '../../styles/sidebar.css';

const ADMIN_EMAIL = 'mackayla.omalley00@gmail.com';

const mainNav = [
  { icon: <FiHome size={17} />,      labelKey: 'nav.myStimuli', path: '/dashboard' },
  { icon: <FiBarChart2 size={17} />, labelKey: 'nav.data',      path: '/data'      },
  { icon: <FiUsers size={17} />,     labelKey: 'nav.profiles',  path: '/profiles'  },
  { icon: <FiSettings size={17} />,  labelKey: 'nav.settings',  path: '/settings'  },
];

function getInitials(name) {
  if (!name) return '?';
  return name.trim().split(/\s+/).map((w) => w[0].toUpperCase()).slice(0, 2).join('');
}

export const Sidebar = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const { userData, currentUser } = useAuth();
  const { t } = useTranslation();
  const isAdmin = userData?.role === 'admin' || currentUser?.email === ADMIN_EMAIL;
  const displayName = currentUser?.displayName || userData?.displayName || currentUser?.email || '';

  const handleLogOut = async () => {
    await logOut();
    navigate('/');
  };

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={toggleSidebar} />}
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-scroll-area">
          <div className="sidebar-user">
            <div className="sidebar-avatar">{getInitials(displayName)}</div>
            <span className="sidebar-username">{displayName}</span>
          </div>

          <nav className="sidebar-nav">
            <p className="sidebar-section-label">{t('nav.mainNavigation')}</p>
            {mainNav.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
                onClick={toggleSidebar}
              >
                {item.icon}
                <span>{t(item.labelKey)}</span>
              </NavLink>
            ))}

            {isAdmin && (
              <>
                <p className="sidebar-section-label" style={{ marginTop: '1.25rem' }}>{t('nav.admin')}</p>
                <NavLink
                  to="/admin"
                  className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
                  onClick={toggleSidebar}
                >
                  <FiShield size={17} />
                  <span>{t('nav.adminDashboard')}</span>
                </NavLink>
              </>
            )}
          </nav>
        </div>

        <div className="sidebar-footer">
          <button className="sidebar-logout-btn" onClick={handleLogOut}>
            <FiLogOut size={16} />
            <span>{t('nav.logOut')}</span>
          </button>
        </div>
      </aside>
    </>
  );
};
